import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'
import { spKycModeFromWire, type SpKycMode } from '../lib/sp-kyc-mode'

const KYC_CONFIG_STALE_MS = 10 * 60 * 1000

interface SpKycConfigurationData {
  kycMode?: string
}

async function fetchSpKycMode(): Promise<SpKycMode> {
  try {
    const { data, status } = await apiClient.get<ApiResponse<SpKycConfigurationData>>(
      '/api/v1/sp/kyc-configuration',
    )
    if (status === 400 || status === 404 || status === 503) {
      return 'unknown'
    }
    if (!data.success || !data.data) {
      return 'unknown'
    }
    return spKycModeFromWire(data.data.kycMode)
  } catch {
    return 'unknown'
  }
}

export function useSpKycConfiguration(enabled = true) {
  return useQuery({
    queryKey: queryKeys.spKyc.configuration(),
    queryFn: fetchSpKycMode,
    enabled,
    staleTime: KYC_CONFIG_STALE_MS,
  })
}
